import links from "@/links/links";
export default {
  actions: {
    POST(item) {
      return this.post(links.MEETING_REGISTERS(), item);
    },
  },
};
